const bold = require('./assets/fonts/ToyotaType-Bold.otf');

export default {
  appFonts: {
    bold,
  },
};
